module.exports = __webpack_public_path__ + "static/img/strona_002.e8a44f8b.jpg";